import { NAME } from './constants';
import { router } from './router';

export const WmsParking = {
	name: NAME,
	router,
};
